export const syncErrorMessages: Record<string, string> = {
  EMPLOYEE_NOT_FOUND:
    "Pracownik o takim numerze kadrowo - płacowym nie istnieje.",
  EMPLOYEE_ANONYMIZED:
    "Pracownik o takim numerze kadrowo - płacowym jest zanonimizowany.",
  EMPLOYEE_NOT_IN_STRUCTURE: "Pracownik nie należy do żadnej struktury.",
  EMPLOYEE_STRUCTURE_IS_INACTIVE:
    "Pracownik nie należy do żadnej struktury.",
  EMPLOYEE_NOT_IN_REQUESTED_STRUCTURE:
    "Ten pracownik należy do innej struktury i nie możemy go zaktualizować.",
  POSITION_TOO_LONG: "Zbyt długa nazwa stanowiska. Max 255 znaków.",
  POSITION_IS_BLANK: "Nazwa stanowiska jest pusta.",
  AREA_TOO_LONG: "Zbyt długa nazwa obszaru. Max 255 znaków",
  AREA_IS_BLANK: "Nazwa obszaru jest pusta.",
  ADDITIONAL_DISPLAY_AREA_TOO_LONG:
    "Zbyt długa nazwa wyświetlanego dodatkowego obszaru. Max 255 znaków.",
  ADDITIONAL_DISPLAY_AREA_IS_BLANK:
    "Nazwa dodatkowego obszaru wyświetlania jest pusta.",
  ADDITIONAL_DISPLAY_AREA_SAME_AS_AREA:
    "Wyświetlany dodatkowy obszar nie może być taki sam jak Obszar.",
  SUPERVISOR_NOT_FOUND:
    "Przełożony o takim numerze kadrowo - płacowym nie istnieje.",
  SUPERVISOR_IN_DIFFERENT_STRUCTURE:
    "Przełożonym nie może być osoba należąca do innej struktury.",
  SUPERVISOR_NOT_CURRENTLY_EMPLOYED:
    "Przełożonym nie może być osoba która nie jest zatrudniona.",
  SUPERVISOR_LOOP:
    "Podwładny pracownika nie może być jego przełożonym.",
  SUPERVISOR_FK_SAME_AS_EMPLOYEE:
    "Numery kadrowo - płacowe pracownika i przełożonego muszą się różnić.",
  CONTRACT_FROM_IS_BLANK: "Data rozpoczęcia umowy jest pusta.",
  CONTRACT_FROM_IS_INVALID_DATE:
    "Niepoprawny format daty rozpoczęcia zatrudnienia wymagane RRRR-MM-DD.",
  CONTRACT_TO_IS_BLANK: "Data zakończenia umowy jest pusta.",
  CONTRACT_TO_IS_INVALID_DATE:
    "Niepoprawny format daty zakończenia zatrudnienia wymagane RRRR-MM-DD.",
  CONTRACT_TO_BEFORE_CONTRACT_FROM:
    "Data rozpoczęcia zatrudnienia nie może być późniejsza niż data zakończenia zatrudnienia.",
  CONTRACT_TYPE: "Rodzaj umowy nie istnieje.",
  EMPLOYMENT_CONTRACT_TYPE_IS_INVALID: "Rodzaj umowy nie istnieje.",
  EMPLOYMENT_FORM_IS_INVALID: "Forma zatrudnienia nie istnieje.",
  WORKING_HOURS_FRACTION_NOMINATOR_NOT_GREATER_THAN_0:
    "Licznik wymiaru etatu musi być większy od 0.",
  WORKING_HOURS_FRACTION_DENOMINATOR_NOT_GREATER_THAN_0:
    "Mianownik wymiaru etatu musi być większy od 0.",
  WORKING_HOURS_FRACTION_NOMINATOR_AND_DENOMINATOR_SHOULD_BE_BOTH_NULL_OR_INT:
    "Licznik i mianownik wymiaru etatu muszą być oba puste lub oba wypełnione.",
  WORKING_HOURS_FRACTION_IS_INVALID:
    "Niepoprawny format wymiaru etatu, wymagane _/_",
  DAILY_WORKING_HOURS_IS_INVALID:
    "Niepoprawny format dziennego wymiaru czasu pracy wymagane  0,00-24,00.",
  DAILY_WORKING_HOURS_IS_BLANK: "Dzienny wymiar godzin jest pusty",
  DAILY_WORKING_HOURS_IS_INVALID_REGEX:
    "Niepoprawny format dziennego wymiaru czasu pracy wymagane  0,00-24,00.",
  CITY_IS_BLANK: "Nazwa miasta jest pusta.",
  CITY_TOO_LONG: "Zbyt długa nazwa miasta max 255 znaków.",
  POSTALCODE_IS_BLANK: "Kod pocztowy jest pusty",
  POSTALCODE_INVALID_FORMAT:
    "Niepoprawny format kodu pocztowego wymagane 00-000.",
  POSTALCODE_TOO_LONG:
    "Zbyt długa nazwa kodu pocztowego. Max 255 znaków.",
  STREETADDRESS_IS_BLANK: "Nazwa ulicy jest pusta.",
  STREETADDRESS_TOO_LONG: "Zbyt długa nazwa ulicy max 255 znaków.",
};

const UNEXPECTED_ERROR = "Wystąpił nieoczekiwany błąd.";

export const getSyncErrorMessage = (error: string | null): string =>
  error ? syncErrorMessages[error] ?? UNEXPECTED_ERROR : "-";
